import Vue from 'vue'
import Component from 'vue-class-component'
import { ErrorDTO } from '@/interfaces/Error.interface'

// You can declare a mixin as the same style as components.
@Component
export default class ErrorMixin extends Vue {
  private mixinName: string = 'ErrorMixin'

  private textError: ErrorDTO = {
    name: {
      constraints: '',
      property: 'name',
      message: '',
      show: false
    },
    email: {
      constraints: '',
      property: 'email',
      message: '',
      show: false
    },
    phone: {
      constraints: '',
      property: 'phone',
      message: '',
      show: false
    },
    folioBeg: {
      constraints: '',
      property: 'folioBeg',
      message: '',
      show: false
    },
    folioEnd: {
      constraints: '',
      property: 'folioEnd',
      message: '',
      show: false
    }
  }

  private bTextError: ErrorDTO = {
    name: {
      constraints: '',
      property: 'name',
      message: '',
      show: false
    },
    email: {
      constraints: '',
      property: 'name',
      message: '',
      show: false
    },
    phone: {
      constraints: '',
      property: 'name',
      message: '',
      show: false
    },
    folioBeg: {
      constraints: '',
      property: 'folioBeg',
      message: '',
      show: false
    },
    folioEnd: {
      constraints: '',
      property: 'folioEnd',
      message: '',
      show: false
    }
  }

  private getError (error: any): ErrorDTO {
    // @ts-ignore: Unreachable code error
    let res: any = this.bTextError
    error.forEach((msg: any) => {
      let errMSG: string = ''
      let errConstraints: string = ''
      msg.errors.forEach((err: any) => {
        errMSG += err.message + ', '
        errConstraints += err.constraints + ', '
      })
      res[msg.property] = {
        property: msg.property,
        message: errMSG,
        constraints: errConstraints,
        show: true
      }
    })
    return res
  }

  private beforeMount () {
    console.log('beforeMount :: Mixin ::::::::::: ', this.mixinName)
  }
}

